import { useState } from 'react';

interface Product {
  id: string;
  name: string;
  price: string;
  originalPrice?: string;
  image: string;
  link: string;
  category: string;
  discount?: string;
}

const products: Product[] = [
  {
    id: '1',
    name: 'Kit Natal Luxo',
    price: 'R$ 65,00',
    originalPrice: 'R$ 85,00',
    discount: '-24%',
    image: 'https://assets.infinitepay.io/unsafe/640x0/filters:quality(75)/https%3A%2F%2Fapi.infinitepay.io%2Fpdv%2Fv1%2Fproducts%2Fvariation%2Fmedia_proxy%2F459e5b82-78bd-4959-873d-f7bd15df7efb%3Fv%3D20251209225014%26q%3Dthumbnail',
    link: 'https://loja.infinitepay.io/retroflavordf/frk1643-kit-natal-luxo',
    category: 'KIT NATAL'
  },
  {
    id: '2',
    name: 'Empada Frango Catupiry 120gr',
    price: 'R$ 12,00',
    image: 'https://assets.infinitepay.io/unsafe/640x0/filters:quality(75)/https%3A%2F%2Fapi.infinitepay.io%2Fpdv%2Fv1%2Fproducts%2Fvariation%2Fmedia_proxy%2Fa3439be7-ba16-440d-8680-7c2b585f2a6f%3Fv%3D20251209224958%26q%3Dthumbnail',
    link: 'https://loja.infinitepay.io/retroflavordf/pgq1947-empada-frango-catupiry-120gr',
    category: 'EMPADAS'
  },
  {
    id: '3',
    name: 'Biscoito da Vovó - O Mais Desejado 50gr',
    price: 'R$ 10,00',
    image: 'https://assets.infinitepay.io/unsafe/640x0/filters:quality(75)/https%3A%2F%2Fapi.infinitepay.io%2Fpdv%2Fv1%2Fproducts%2Fvariation%2Fmedia_proxy%2F1b1dc16b-9e91-4367-8268-d5f850e25d0f%3Fv%3D20251209225004%26q%3Dthumbnail',
    link: 'https://loja.infinitepay.io/retroflavordf/qpb5682-biscoito-da-vovo-o-mais-desejado-50gr',
    category: 'BISCOITO DA VOVÓ'
  },
  {
    id: '4',
    name: 'Capuccino 250gr',
    price: 'R$ 45,00',
    image: 'https://assets.infinitepay.io/unsafe/640x0/filters:quality(75)/https%3A%2F%2Fapi.infinitepay.io%2Fpdv%2Fv1%2Fproducts%2Fvariation%2Fmedia_proxy%2F25560eb6-0de2-4aee-9889-a1a408bc2a72%3Fv%3D20251210063917%26q%3Dthumbnail',
    link: 'https://loja.infinitepay.io/retroflavordf/dzl1654-capuccino-250gr',
    category: 'TODOS'
  },
  {
    id: '5',
    name: 'Kit Presente de Natal 1',
    price: 'R$ 55,00',
    image: 'https://assets.infinitepay.io/unsafe/640x0/filters:quality(75)/https%3A%2F%2Fapi.infinitepay.io%2Fpdv%2Fv1%2Fproducts%2Fvariation%2Fmedia_proxy%2F46e0c7cb-ec5b-4fcc-be64-79358850dd9f%3Fv%3D20251209225011%26q%3Dthumbnail',
    link: 'https://loja.infinitepay.io/retroflavordf/wuo2363-kit-presente-de-natal-1',
    category: 'KIT NATAL'
  },
  {
    id: '6',
    name: 'Cone de Biscoito Natal',
    price: 'R$ 12,00',
    image: 'https://assets.infinitepay.io/unsafe/640x0/filters:quality(75)/https%3A%2F%2Fapi.infinitepay.io%2Fpdv%2Fv1%2Fproducts%2Fvariation%2Fmedia_proxy%2F7cc0fd64-09bd-43a5-9660-9a338fc9aead%3Fv%3D20251209225008%26q%3Dthumbnail',
    link: 'https://loja.infinitepay.io/retroflavordf/bco3355-cone-de-biscoito-natal',
    category: 'BISCOITO DA VOVÓ'
  },
  {
    id: '7',
    name: 'Empada Frango com Catupiry 80gr',
    price: 'R$ 10,00',
    image: 'https://assets.infinitepay.io/unsafe/640x0/filters:quality(75)/https%3A%2F%2Fapi.infinitepay.io%2Fpdv%2Fv1%2Fproducts%2Fvariation%2Fmedia_proxy%2Fece031ff-bb2c-4335-8ff4-72c0899a3676%3Fv%3D20251209224954%26q%3Dthumbnail',
    link: 'https://loja.infinitepay.io/retroflavordf/yig7785-empada-frango-com-catupory-80gr',
    category: 'EMPADAS'
  },
  {
    id: '8',
    name: 'Empadão 650gr',
    price: 'R$ 45,00',
    image: 'https://assets.infinitepay.io/unsafe/640x0/filters:quality(75)/https%3A%2F%2Fapi.infinitepay.io%2Fpdv%2Fv1%2Fproducts%2Fvariation%2Fmedia_proxy%2F425a8760-349a-44e3-ae04-968a04dc0f40%3Fv%3D20251209225002%26q%3Dthumbnail',
    link: 'https://loja.infinitepay.io/retroflavordf/mgd8280-empadao-650-gr',
    category: 'EMPADAS'
  }
];

const categories = ['TODOS', 'EMPADAS', 'KIT NATAL', 'BISCOITO DA VOVÓ'];

export default function Products() {
  const [selectedCategory, setSelectedCategory] = useState('TODOS');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredProducts = products.filter(product => {
    const matchesCategory = selectedCategory === 'TODOS' || product.category === selectedCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <section id="produtos" className="py-20 px-6 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nossos Produtos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Delícias artesanais feitas com carinho e ingredientes selecionados
          </p>
        </div>

        {/* Search */}
        <div className="mb-8 max-w-xl mx-auto">
          <div className="relative">
            <input
              type="text"
              placeholder="Pesquisar produtos..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-5 py-3 pl-12 rounded-full border-2 border-gray-200 focus:border-amber-500 focus:outline-none text-sm transition-colors"
            />
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
          </div>
        </div>

        {/* Categories */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                selectedCategory === category
                  ? 'bg-amber-600 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 border-2 border-gray-200 hover:border-amber-500 hover:text-amber-600'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {product.discount && (
                  <div className="absolute top-3 left-3 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
                    {product.discount}
                  </div>
                )}
              </div>
              
              <div className="p-5">
                <h3 className="text-base font-semibold text-gray-900 mb-3 line-clamp-2 min-h-[48px]">
                  {product.name}
                </h3>
                
                <div className="flex items-center gap-2 mb-4">
                  <span className="text-xl font-bold text-amber-600">
                    {product.price}
                  </span>
                  {product.originalPrice && (
                    <span className="text-sm text-gray-400 line-through">
                      {product.originalPrice}
                    </span>
                  )}
                </div>

                <a
                  href={product.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-amber-600 hover:bg-amber-700 text-white py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 shadow-md flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-shopping-cart-line text-lg"></i>
                  Adicionar ao Carrinho
                </a>
              </div>
            </div>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div className="text-center py-16">
            <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-xl text-gray-500">Nenhum produto encontrado</p>
          </div>
        )}
      </div>
    </section>
  );
}
